import { linkTo } from '../linkTo';

export const makeSuperSentinelBulkActivationColumn = () => {
  const col = [
    {
      header: 'Device ID',
      accessorKey: 'deviceId',
      sortable: false,
      enableColumnFilter: false,
      size: 200,
      cell: ({ row }) => linkTo('/devices', row.original.deviceId, row.original.deviceId),
    },
    {
      header: 'Days',
      accessorKey: 'days',
      sortable: false,
      enableColumnFilter: false,
      size: 100,
      cell: ({ row }) => <span>{row.original.days ?? '-'}</span>,
    },
    {
      header: 'Import Status',
      accessorKey: 'importItemStatus',
      sortable: false,
      enableColumnFilter: false,
      size: 150,
      cell: ({ row }) => <span>{row.original.importItemStatus ?? '-'}</span>,
    },
    {
      header: 'Sentinel Status',
      accessorKey: 'currentSuperSentinelStatus',
      sortable: false,
      enableColumnFilter: false,
      size: 160,
      cell: ({ row }) => <span>{row.original.currentSuperSentinelStatus ?? '-'}</span>,
    },
    {
      header: 'Numeber of Sightings',
      accessorKey: 'numberOfSightings',
      sortable: false,
      enableColumnFilter: false,
      size: 160,
      cell: ({ row }) => <span>{row.original.numberOfSightings ?? '-'}</span>,
    },
    {
      header: 'Sightings Produced',
      accessorKey: 'numberOfSightings',
      id: 'sightingsProduced',
      sortable: true,
      enableColumnFilter: false,
      size: 160,
      cell: ({ row }) => {
        const count = row.original.numberOfSightings;
        const isYes = Boolean(count);
        return (
          <span
            style={{
              display: 'inline-block',
              padding: '2px 10px',
              borderRadius: '4px',
              backgroundColor: isYes ? 'skyblue' : '#d3d3d3',
              textAlign: 'center',
              minWidth: '20px',
            }}
          >
            {isYes ? 'Yes' : 'No'}
          </span>
        );
      },
    },
  ] as Array<any>;

  return col;
};
